// components/loader/g-loader.tsx
import React from "react";
import { CircularProgress, Backdrop } from "@mui/material";
import { useLoader } from "./loader-context"; // Import the loader context

const Loader: React.FC = () => {
  const { isLoading } = useLoader(); // Get isLoading from context

  return (
    <Backdrop
      sx={{ color: "#011D33", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
